import AwardsSection from "@components/new-ui/AwardsSection";
import CTASection from "@components/new-ui/CTASection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { MainContent, PressReleaseHerosection, PressReleaseSummary } from "./gallabox-raises-3.5-million-to-fuel-its-mission";
import React from "react";
import ClientLogos from "@components/new-ui/ClientLogos";

const content: PressReleaseSummary[] = [
    {
        title: "Karthik Jagannathan, CEO & Co-founder, Gallabox",
        description: (
            <p>
                “We are thrilled to partner Prime Venture Partners and 100x Entrepreneur Fund as they share our optimism for automating customer conversation workflows for SMBs at
                scale. Indian SMBs are maturing and there is an immediate need for digitisation & automation to help them with rapid sales growth and transformation. We are excited
                about the Bharat-SMB opportunity and want to empower a million SMBs with enterprise-level sophisticated tech and tools to acquire and retain customers”
            </p>
        ),
    },
    {
        title: "Sanjay Swamy, Managing Partner, Prime Venture Partners",
        description: (
            <p>
                “Karthik, Yathin and Yogesh are passionate about hyperlocal and SMBs like no other team we’ve met - and their deep insights made backing them a simple decision for
                us at Prime. It’s no secret that, around the world, such businesses have to be transformed in the next 2-3 years through digitization and automation - and
                Gallabox’s WhatsApp automation with a quick start ready-to-use recipes will help the business owner focus on their core business and yet modernize and automate
                their customer conversations to compete with big players on an equal footing.
                <br />
                With increasing WhatsApp penetration, the conversations with customers have now moved to whatsapp as the default medium for businesses. However, there are no
                easy-to-use tools to manage multiple concurrent conversations across multiple sales/support agents. Currently 80% of leads are lost as agents mostly use their
                personal whatsapp numbers. This results in lack of transparency across the org, multiple parallel conversations with the same customer, poor customer experience
                leading to lead drop offs. We are delighted to back a stellar team solving a core challenge for SMBs and excited about the massive opportunity ahead.”
            </p>
        ),
    },
    {
        title: "Siddhartha Ahluwalia, 100x Entrepreneur Fund",
        description: (
            <p>
                &quot;The Gallabox team&apos;s understanding of the needs of small and medium businesses (SMBs) is unparalleled that I have seen in the industry. They have
                leveraged three important trends: WhatsApp is the business communication application of India whereas in US its Slack or Microsoft Teams, SMBs for the first time
                want to leverage their customer data for driving better relationships with their customers and thus sales, and the most important one SMS has become a redundant
                medium for businesses to reach out to the customers since all personal communication has moved from SMS to WhatsApp on mobile, thereby lowering the utility for the
                SMS application in smartphones. The current round enables the Gallabox team to serve SMBs to build their first CRM (Customer Relationship Management) software using
                Gallabox’s no-code platform. The Gallabox investment matches our fund thesis of backing exceptional seed stage SaaS startups run by founders who have unique
                insights and experiences in the markets they operate in&quot;.
            </p>
        ),
    },
    {
        title: "About Gallabox",
        description: (
            <p>
                Founded in 2021, the company is headquartered in Chennai. Gallabox is a growth engine on WhatsApp for SMBs and mid-market businesses. An easy-to-use, no-code
                conversational platform, Gallabox increases sales conversions for SMBs. The company’s mission is to empower businesses to make lasting connections with their
                customers To know more about Gallabox, please visit:{" "}
                <a href="https://gallabox.com/" className="text-blue-500 underline">
                    https://gallabox.com/
                </a>
            </p>
        ),
    },
    {
        title: "About Prime Venture Partners",
        description: (
            <p>
                Prime Venture Partners is an early-stage VC fund managed by partners with deep experience both as entrepreneurs and operators. Led by Amit Somani, Sanjay Swamy &
                Shripati Acharya, the fund is focused on building disruptive product companies out of India, and addresses a much needed gap in the Indian startup ecosystem - by
                bringing a combination of first-hand entrepreneurial experience, operating expertise and meaningful capital. Prime is a high conviction, high support investor and
                believes in backing star teams with differentiated ideas. Prime has a rich portfolio of category creating companies including Quizizz, MyGate, MFine, PlanetSpark,
                MyGate, Dozee, NiYO, Sunstone Eduversity, KredX, WheelsEye and more. For more information, please visit{" "}
                <a href="https://www.primevp.in/" className="text-blue-500 underline">
                    www.primevp.in.
                </a>
                <br />
                <br />
                Whatsapp-for-Business is a preferred platform by businesses to reach out to customers, offer support, receive payments, and even verify documents. However,
                Whatsapp-for-Business is useful to manage the limited number of conversations and has basic tools which help with automated replies and showcase product catalogs.
                Gallabox on the other hand is a single, collaborative conversational platform that helps SMBs and users manage contacts and conversations from various channels and
                makes it easier for them to respond through a collaborative dashboard.
            </p>
        ),
    },
];

const mainContentData: PressReleaseSummary[] = [
    {
        description: <p>Investors: Prime Venture Partners,100x Entrepreneur Fund and other strategic angels</p>,
    },
    {
        description: (
            <p>
                Chennai/Bangalore, 17 November 2022:{" "}
                <a href="https://gallabox.com/" className="underline">
                    Gallabox{" "}
                </a>
                , a conversational commerce platform which helps SMBs sell on WhatsApp has raised USD 1.2 million in seed funding led by Prime Venture Partners with participation
                from 100x Entrepreneur Fund.
            </p>
        ),
    },

    {
        description: (
            <p>
                &quot;The no-code conversational commerce platform leverages WhatsApp Business API to help small and mid-market businesses improve their sales conversions and offer
                a full mobile experience to their customers without the need for a mobile app. The SaaS startup will use the fresh capital for product development and to
                aggressively grow and expand in India and in other geographies. Several noted angel investors also participated in the round including Pallav Nadhani (ex-CEO,
                FusionCharts), Abhishek Rungta (Indus Net Technologies), SV Swaroop Reddy (ex-SPI Cinemas), and Siva Rajamani (co-Founder & CEO, Everstage).
            </p>
        ),
    },

    {
        description: (
            <p>
                With more than 2 BN users on WhatsApp - and more than 500 million in India - coupled with SMS becoming increasingly spam-prone, businesses are fast discovering
                WhatsApp to be the best way to connect with their customers. While enterprises have the resources to build tools to communicate and transact with their customers on
                WhatsApp, small & medium-sized businesses do not have the budget or skill-sets to build these sophisticated tools. Gallabox makes it easy for such businesses to be
                up and running in a matter of minutes and leverage a pre-built library of recipes to deliver a world class experience to clients, turning customer conversations
                into sales.
                <br />
            </p>
        ),
    },
    {
        description: (
            <p>
                Founded by{" "}
                <a href="https://www.linkedin.com/in/jkarthik/" className="underline">
                    Karthik Jagannathan
                </a>
                ,{" "}
                <a href="https://www.linkedin.com/in/yogeshnarayanan/" className="underline">
                    Yogesh Narayanan
                </a>{" "}
                &{" "}
                <a href="https://www.linkedin.com/in/yathin/" className="underline">
                    Yathin Panchanathan
                </a>
                , Gallabox now serves more than 500 paying customers including PVR, ShipRocket, CreditMantri, and Pickyourtrail across D2C, Education, Health & Wellness, Financial
                and Travel services. Majority of these customers are in India with several of them across 12 different countries.
            </p>
        ),
    },

    {
        description: (
            <p>
                India is home to 75 million SMBs with 20 million of them digitally influenced, according to a report by{" "}
                <a href="https://zinnov.com/" className="underline">
                    Zinnov
                </a>
                . Acquiring customers digitally, SMBs spend enormous efforts and marketing budgets to generate leads, but struggle to convert them because of opacity of customer
                conversations, multiple touch-points, and dependence on sales team-members to provide updates. Gallabox enables businesses to interact with customers on WhatsApp
                instantly, understand requirements better, and engage with the customer better. Most SMBs cannot afford to develop interactive experiences like a mobile app unlike
                large companies.
            </p>
        ),
    },
    {
        description: (
            <p>
                Currently investing out of its USD 120 million Fund IV, Prime Venture Partners is typically the first institutional investor in startups and focuses on companies
                with an innovative approach to solving fundamental problems through technology. Prime’s mission is to partner early with entrepreneurs and help build world-class
                technology companies that are addressing some of India’s most important problems. Prime’s prominent Limited Partners include International Finance Corporation
                (IFC), part of the World Bank Group, a top-tier University endowment, global family offices and institutions, and numerous global technology entrepreneurs. In
                addition to prior focus areas, the firm has expanded its portfolio into new areas, notably, EVs, B2B, Web3 and Gaming infrastructure platforms.
            </p>
        ),
    },
];

const HerosectionData: PressReleaseHerosection = {
    title: "PRESS RELEASE",
    description: "Gallabox, a conversational commerce platform, raises $1.2 million to help SMBs grow their sales on WhatsApp",
    releaseDate: "Thursday, November 17, 2022",
};
const Press_release_fuel: React.FC = () => {
    return (
        <NewLayout
            title={"Gallabox Press Release | $1.2M Seed Funding"}
            description={
                "Gallabox raises $1.2M in a seed investment led by Prime Venture Partners to help SMBs grow their sales on WhatsApp. Learn how Gallabox is utilizing this funding to ensure businesses automate their growth on WhatsApp."
            }
            canonical="https://gallabox.com/news/gallabox-raises-1.2-million-to-help-smbs"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/press/gallabox-press-2022.png" }}
        >
            <PressReleaseHerosection {...HerosectionData} />
            <section>
                <MainContent summary={mainContentData} />
            </section>
            <section>
                <MainContent aboutData={content} />
            </section>

            <div>
                <div className="w-full mb-20">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos />
                </div>
                <IntegrationSection />
                <AwardsSection />
                <CTASection title="Turn connections into conversions" description="Take Gallabox for a 7-day ride" />
            </div>
        </NewLayout>
    );
};

export default Press_release_fuel;
